<template>
  <template v-if="model.isAccepted">
    Insurance coverage changes regularly. Please check with <strong> {{ model.insuranceName }} </strong> to confirm if
    your provider is in-network.
  </template>

  <template v-else-if="model.isNotAccepted">
    We can't confirm this provider accepts the insurance you selected, {{ model.insuranceName }}. Please check with your
    insurance carrier to make sure the provider is in your plan network. You may have a higher copay or be responsible
    for the full cost of your visit.
  </template>

  <template v-else-if="model.isNoProviderData">
    We can't confirm this provider accepts the insurance you selected, {{ model.insuranceName }}. Please check with your
    insurance carrier to make sure the provider is in your plan network.
  </template>
</template>

<script setup>
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>
